import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { allocationService, Util } from "../../services";
import moment from "moment";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

export const EmployeeAllocation = ({
  projects,
  allocationTypes,
  setShow,
  dashboardRefresh,
}) => {
  // console.log(projects, "projectsprojectsprojects")
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    setFilteredProjects([...projects]);
  }, [projects]);

  const formik = useFormik({
    initialValues: {
      project: "",
      allocation: null,
      alloc100: true,
      alloc50: false,
      alloc25: false,
      allocOther: null,
      allocPartial: false,
      ot: false,
      hours: null,
      startDate: null,
      endDate: null,
    },
    validate: (data) => {
      let errors = {};
      if (!data.project) {
        errors.project = "Project is required*";
      }
      if (!data.startDate) {
        errors.startDate = "Start Date is required*";
      }
      if (!data.endDate) {
        errors.endDate = "End Date is required*";
      }
      if (data.endDate && data.startDate) {
        if (moment(data.startDate) > moment(data.endDate)) {
          errors.endDate = "End Date is must be above than start date";
        }
      }
      return errors;
    },
    onSubmit: (data) => {
      createEmployeeAllocation(data);
      setShowMessage(true);
      formik.resetForm();
    },
  });

  const handleDateChange = (date) => {
    formik.setFieldValue("startDate", date);
    formik.setFieldValue("endDate", "");
  };

  // if (!allocOther) formik.setFieldValue("hours", "");

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const createEmployeeAllocation = async (data) => {
    setShow(false);
    const dataobj = {
      projectId: data.project.id,
      startDate: moment(data.startDate).format("DD-MM-YYYY"),
      endDate: moment(data.endDate).format("DD-MM-YYYY"),
      allocationType: fetchAllocation(data),
      percentage: fetchPercentage(data),
      hour: data.hours ? parseInt(data.hours) : 0,
    };

    if (
      formik.values.alloc100 ||
      formik.values.alloc50 ||
      formik.values.alloc25 ||
      formik.values.allocOther > 0 ||
      formik.values.hours > 0
    ) {
      try {
        allocationService.createAllocation(dataobj).then(
          (resp) => {
            var currentuser = {};
            currentuser = JSON.parse(localStorage.getItem("user"));
            toast.success(
              "Your allocation request has been shared with " +
                currentuser.superior.firstName +
                " " +
                currentuser.superior.lastName
            );
            setTimeout(() => {
              dashboardRefresh();
            }, 3000);
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      } catch (error) {
        toast.error("Unable to create allocation...");
      }
    } else {
      toast.error("Allocation percentage not selected properly");
    }
  };

  const fetchAllocation = (data) => {
    // console.log(data, "dataaaaaaaaa");
    var code = "100";
    if (data) {
      if (data.alloc100) {
        code = "100";
      } else if (data.allocPartial) {
        code = "PT";
      } else if (data.ot) {
        code = "OT";
      } else {
        code = "";
      }
    }

    var result = allocationTypes.filter((obj) => {
      return obj.code === code;
    });
    return result[0].id;
  };

  const fetchPercentage = (data) => {
    var result = 0;
    if (data) {
      if (data.alloc100) {
        result = 100;
      } else if (data.allocPartial) {
        if (data.alloc50) {
          result = 50;
        } else if (data.alloc25) {
          result = 25;
        } else {
          result = data.allocOther;
        }
      } else {
        result = 0;
      }
    }
    return result;
  };

  const searchProject = (event) => {
    setTimeout(() => {
      let _filteredProjects;
      if (!event.query.trim().length) {
        _filteredProjects = [...projects];
      } else {
        _filteredProjects = projects.filter((p) => {
          return p.title.toLowerCase().startsWith(event.query.toLowerCase());
        });
      }
      setFilteredProjects(_filteredProjects);
    }, 250);
  };

  const allocHandler = (e) => {
    formik.handleChange(e);
    if (e.target.name === "alloc50") {
      formik.setFieldValue("alloc25", false);
      formik.setFieldValue("allocOther", "");
    }
    if (e.target.name === "alloc25") {
      formik.setFieldValue("alloc50", false);
      formik.setFieldValue("allocOther", "");
    }
    if (e.target.name === "allocOther") {
      formik.setFieldValue("alloc50", false);
      formik.setFieldValue("alloc25", false);
    }
    if (!formik.values.ot) {
      formik.values.hours = "";
    }
    if (!formik.values.allocPartial) {
      formik.values.allocOther = "";
    }
    switch (e.target.name) {
      case "allocPartial":
        formik.setFieldValue("alloc100", false);
        formik.setFieldValue("ot", false);
        formik.values.hours = 0;
        break;
      case "alloc100":
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("ot", false);
        formik.values.hours = 0;
        break;
      case "ot":
        formik.setFieldValue("alloc100", false);
        formik.setFieldValue("allocPartial", false);
        break;
      default:
      //
    }
  };

  return (
    <div>
      {/* <h1>Employee</h1> */}
      <form onSubmit={formik.handleSubmit} className="mt-5">
        <div className="p-fluid" style={{ paddingBottom: "20px" }}>
          <div className="field">
            <label
              htmlFor="name"
              className={classNames({ "p-error": isFormFieldValid("name") })}
            >
              Project*
            </label>
            <span className="p-float-label">
              <Dropdown
                filter
                id="project"
                name="project"
                placeholder="Select Project"
                optionLabel="title"
                options={filteredProjects}
                onChange={formik.handleChange}
                value={formik.values.project}
                appendTo="self"
              />
            </span>
            {getFormErrorMessage("project")}
          </div>
          <div className="grid date-selection">
            <div className="col">
              <div className="field">
                <label htmlFor="date">Start Date*</label>
                <span className="p-float-label">
                  <Calendar
                    type="date"
                    id="date"
                    name="startDate"
                    value={formik.values.startDate}
                    onChange={(e) => handleDateChange(e.target.value)}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    showIcon
                    placeholder="Start Date"
                    minDate={new Date()}
                  />
                  {getFormErrorMessage("startDate")}
                </span>
              </div>
            </div>
            <div className="col">
              <div className="field">
                <label htmlFor="date">End Date*</label>
                <span className="p-float-label">
                  <Calendar
                    id="date"
                    type="date"
                    name="endDate"
                    value={formik.values.endDate}
                    onChange={formik.handleChange}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    showIcon
                    placeholder="End Date"
                    minDate={new Date(formik.values.startDate)}
                    disabled={!formik.values.startDate}
                  />
                  {getFormErrorMessage("endDate")}
                </span>
              </div>
            </div>
          </div>
          <div className="grid mt-2">
            <div className="col-4">
              <div className="field-checkbox">
                <Checkbox
                  className="commonCheckbox"
                  inputId="alloc100"
                  name="alloc100"
                  checked={formik.values.alloc100}
                  onChange={allocHandler}
                />
              </div>
              <label className="checkbox-label" htmlFor="alloc100">
                100% Allocation
              </label>
              {getFormErrorMessage("allocations")}
            </div>
            <div className="col-4">
              <div className="field-checkbox">
                <Checkbox
                  className="commonCheckbox"
                  inputId="allocPart"
                  name="allocPartial"
                  checked={formik.values.allocPartial}
                  onChange={allocHandler}
                />
              </div>
              <label className="checkbox-label" htmlFor="allocPart">
                Partial Allocation
              </label>
            </div>
            <div className="col-4">
              <div className="field-checkbox mr-4">
                <Checkbox
                  className="commonCheckbox"
                  inputId="allocOt"
                  name="ot"
                  checked={formik.values.ot}
                  onChange={allocHandler}
                />
              </div>
              <label className="checkbox-label ml-3" htmlFor="allocOt">
                OT
              </label>
            </div>
          </div>
          {formik.values.allocPartial && (
            <div className="partial-container">
              <div className="grid">
                <div className="col-4 pt-4">
                  <label htmlFor="all50">50% Allocation</label>
                </div>
                <div className="col-8">
                  <div className="field-checkbox">
                    <Checkbox
                      className="commonCheckbox"
                      inputId="alloc50"
                      name="alloc50"
                      checked={formik.values.alloc50}
                      onChange={allocHandler}
                    />
                  </div>
                </div>
              </div>
              <div className="grid mt-3">
                <div className="col-4 pt-4">
                  <label htmlFor="all50">25% Allocation</label>
                </div>
                <div className="col-8">
                  <div className="field-checkbox">
                    <Checkbox
                      className="commonCheckbox"
                      inputId="alloc25"
                      name="alloc25"
                      checked={formik.values.alloc25}
                      onChange={allocHandler}
                    />
                  </div>
                </div>
              </div>
              <div className="grid mt-3">
                <div className="col-4 pt-4">
                  <label htmlFor="other">Other %</label>
                </div>
                <div className="col-8">
                  <InputText
                    inputId="allocOther"
                    name="allocOther"
                    style={{ width: "100px" }}
                    value={formik.values.allocOther}
                    onKeyPress={Util.preventChar}
                    onChange={(e) => {
                      if (e.target.value < 100) {
                        formik.handleChange(e);
                        formik.setFieldValue("alloc50", false);
                        formik.setFieldValue("alloc25", false);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {formik.values.ot && (
            <div className="partial-container">
              <div className="grid mt-0">
                <div className="col-4 pt-4">
                  <label htmlFor="other">Hours</label>
                </div>
                <div className="col-8">
                  <span className="p-float-label">
                    <InputText
                      name="hours"
                      style={{ width: "100px" }}
                      value={formik.values.hours}
                      onKeyPress={Util.preventChar}
                      onChange={(e) => {
                        if (e.target.value < 10) {
                          formik.handleChange(e);
                        }
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="" style={{ textAlign: "right", paddingBottom: "80px" }}>
          <Button
            type="button"
            label="Cancel"
            className="p-button-rounded p-button-secondary"
            onClick={() => {
              setShow(false);
              formik.resetForm();
            }}
          />
          <Button label="Allocate Now" className="p-button-rounded ml-2" />
        </div>
      </form>
    </div>
  );
};
